import { isAfter, isBefore, isSameDay } from "date-fns";
import { useMemo } from "react";

import { calculatePlannerVisitPossibleDaysStatus } from "../calculatePlannerVisitPossibleDaysStatus";
import { VisitStatusTimelineFragment } from "../fragment.generated";
import { useTimelineRange } from "./useTimelineRange";

type UseTimelineMarkerParams = {
    timelineRange: ReturnType<typeof useTimelineRange>;
    markerDate: Date;
    possibleDays: VisitStatusTimelineFragment["possibleDays"];
};

export function useTimelineMarker({ timelineRange, markerDate, possibleDays }: UseTimelineMarkerParams) {
    return useMemo(() => {
        if (timelineRange === null) return null;
        const { firstDateInRange, lastDateInRange, dayData } = timelineRange;

        // Clamp marker date to timeline range
        const clampedMarkerDate = isAfter(markerDate, lastDateInRange)
            ? lastDateInRange
            : isBefore(markerDate, firstDateInRange)
              ? firstDateInRange
              : markerDate;

        // Find marker position
        const markerDayIndex = dayData.findIndex(({ day }) => isSameDay(day, clampedMarkerDate));
        const markerStatus = calculatePlannerVisitPossibleDaysStatus(possibleDays, clampedMarkerDate);
        const markerPositionPercent = (markerDayIndex / dayData.length) * 100;

        return {
            clampedMarkerDate,
            markerDayIndex,
            markerStatus,
            markerPositionPercent,
        };
    }, [timelineRange, markerDate, possibleDays]);
}
